import { render, staticRenderFns } from "./ProfesorAlumnos.vue?vue&type=template&id=01f6756a"
import script from "./ProfesorAlumnos.vue?vue&type=script&lang=js"
export * from "./ProfesorAlumnos.vue?vue&type=script&lang=js"
import style0 from "./ProfesorAlumnos.vue?vue&type=style&index=0&id=01f6756a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports